import {
  Component,
  OnInit,
  OnDestroy,
  Output,
  Input,
  EventEmitter,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MdbModalRef, MdbModalService } from "mdb-angular-ui-kit/modal";
import { Router } from "@angular/router";
import { Q, V } from "@angular/cdk/keycodes";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import Swal from "sweetalert2";
import { EditorModule, TINYMCE_SCRIPT_SRC } from "@tinymce/tinymce-angular";
import { environment } from "src/environments/environment";
// import { Editor } from "ngx-editor";

@Component({
  selector: "app-ideas-inner",
  templateUrl: "./ideas-inner.component.html",
  styleUrls: ["./ideas-inner.component.css"],
})
export class IdeasInnerComponent implements OnInit, OnDestroy {
  @Input() showSkip: boolean = true;
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() isFinished = new EventEmitter<void>();

  idea_id: any;
  idea_name: any;
  track_name: any;

  // editor: Editor;

  constructor(
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private router: Router
  ) {}
  // safeSrc1 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/c9F5kMUfFKk");
  // safeSrc2 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://youtu.be/HTJKD6PzvVE");
  // safeSrc3 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=wWpEiSKeDDo&t=2s");
  // safeSrc4 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=C91utiNU0cI");
  // safeSrc5 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=Y2-5aPewZCA");
  // safeSrc6 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=rlPVu0EzGAY");
  // safeSrc7 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/c9F5kMUfFKk");
  listing: any;
  auth: any;
  ids: any;
  track: any;
  loaderDisplayStyle = "none";
  popupDisplayStyles = [
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
  ];

  public myForm = new FormGroup({
    ques1: new FormControl("", Validators.required),
    ques2: new FormControl("", Validators.required),
    ques3: new FormControl("", Validators.required),
    ques4: new FormControl("", Validators.required),
    ques5: new FormControl("", Validators.required),
    ques6: new FormControl("", Validators.required),
    ques7: new FormControl("", Validators.required),
    ques8: new FormControl("", Validators.required),
    ques9: new FormControl("", Validators.required),
    ques10: new FormControl("", Validators.required),
    ques11: new FormControl("", Validators.required),
    ques12: new FormControl("", Validators.required),
    ques13: new FormControl("", Validators.required),
    ques14: new FormControl("", Validators.required),
    ques15: new FormControl("", Validators.required),
    ques16: new FormControl("", Validators.required),
    ques17: new FormControl("", Validators.required),
  });

  ngOnDestroy(): void {
    // this.editor.destroy();
  }

  ngOnInit(): void {
    // this.editor = new Editor();
    // console.log(this.auth)

    // Relaods page on first visit
    // if (!localStorage.getItem("foo")) {
    //   localStorage.setItem("foo", "no reload");
    //   location.reload();
    // } else {
    //   localStorage.removeItem("foo");
    // }
    this.fetchData();
  }

  fetchData() {
    this.idea_id = localStorage.getItem("tempid");
    this.idea_name = localStorage.getItem("prelname");
    this.track_name = localStorage.getItem("preltrack");
    var body: any = new FormData();
    body.append("id", this.idea_id);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };

    this.loaderDisplayStyle = "block";
    this.isLoading.emit(true);

    this.http
      .post<any>(environment.API_URL + "getQuessionare/", body, { headers })
      .subscribe((data) => {
        this.loaderDisplayStyle = "block";
        this.isLoading.emit(true);

        this.listing = data;
        console.log(this.listing.id);
        localStorage.setItem("listing", this.listing.id);
        localStorage.setItem("ques1", this.listing.ques1);
        localStorage.setItem("ques2", this.listing.ques2);
        localStorage.setItem("ques3", this.listing.ques3);
        localStorage.setItem("ques4", this.listing.ques4);
        localStorage.setItem("ques5", this.listing.ques5);
        localStorage.setItem("ques6", this.listing.ques6);
        localStorage.setItem("ques7", this.listing.ques7);
        localStorage.setItem("ques8", this.listing.ques8);
        localStorage.setItem("ques9", this.listing.ques9);
        localStorage.setItem("ques10", this.listing.ques10);
        localStorage.setItem("ques11", this.listing.ques11);
        localStorage.setItem("ques12", this.listing.ques12);
        localStorage.setItem("ques13", this.listing.ques13);
        localStorage.setItem("ques14", this.listing.ques14);
        localStorage.setItem("ques15", this.listing.ques15);
        localStorage.setItem("ques16", this.listing.ques16);
        localStorage.setItem("ques17", this.listing.ques17);

        this.myForm.setValue({
          ques1: this.listing.ques1,
          ques2: this.listing.ques2,
          ques3: this.listing.ques3,
          ques4: this.listing.ques4,
          ques5: this.listing.ques5,
          ques6: this.listing.ques6,
          ques7: this.listing.ques7,
          ques8: this.listing.ques8,
          ques9: this.listing.ques9,
          ques10: this.listing.ques10,
          ques11: this.listing.ques11,
          ques12: this.listing.ques12,
          ques13: this.listing.ques13,
          ques14: this.listing.ques14,
          ques15: this.listing.ques15,
          ques16: this.listing.ques16,
          ques17: this.listing.ques17,
        });

        this.loaderDisplayStyle = "none";
        this.isLoading.emit(false);
      });
  }

  onquesN(n: number) {
    const questionKey = "ques" + n;
    this.loaderDisplayStyle = "block";
    this.isLoading.emit(true);

    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append(questionKey, this.myForm.value.ques3);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, { headers })
      .subscribe((data) => {
        var body: any = new FormData();
        body.append("id", this.idea_id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "getQuessionare/", body, { headers })
          .subscribe((data) => {
            this.listing = data;
            localStorage.setItem(questionKey, this.listing[questionKey]);
            this.loaderDisplayStyle = "none";
            this.isLoading.emit(false);

            Swal.fire({
              position: "center",
              // icon: 'success',
              title: "Your response has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      });
  }

  async onsubmit(allowSkip: boolean = false) {
    this.loaderDisplayStyle = "block";
    this.isLoading.emit(true);

    this.myForm.markAllAsTouched();
    if (this.myForm.invalid) {
      if (allowSkip) {
        const result = await Swal.fire({
          position: "center",
          icon: "warning",
          title: "Incomplete form",
          text: "You have not answered all the questions yet. Your idea's entry to Eureka will only be valid once you have answered all the questions. You can do this later by accessing this page from the dashboard.",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Submit anyway",
          cancelButtonText: "Go back",
          reverseButtons: true,
        });

        if (!result.isConfirmed) {
          this.loaderDisplayStyle = "none";
          this.isLoading.emit(false);
          return;
        }
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Incomplete form",
          text: "Please answer all the questions before submitting, or skip the form for now and fill it later.",
        });
        this.loaderDisplayStyle = "none";
        this.isLoading.emit(false);
        return;
      }
    }

    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques1", this.myForm.value.ques1 ?? "");
    body.append("ques2", this.myForm.value.ques2 ?? "");
    body.append("ques3", this.myForm.value.ques3 ?? "");
    body.append("ques4", this.myForm.value.ques4 ?? "");
    body.append("ques5", this.myForm.value.ques5 ?? "");
    body.append("ques6", this.myForm.value.ques6 ?? "");
    body.append("ques7", this.myForm.value.ques7 ?? "");
    body.append("ques8", this.myForm.value.ques8 ?? "");
    body.append("ques9", this.myForm.value.ques9 ?? "");
    body.append("ques10", this.myForm.value.ques10 ?? "");
    body.append("ques11", this.myForm.value.ques11 ?? "");
    body.append("ques12", this.myForm.value.ques12 ?? "");
    body.append("ques13", this.myForm.value.ques13 ?? "");
    body.append("ques14", this.myForm.value.ques14 ?? "");
    body.append("ques15", this.myForm.value.ques15 ?? "");
    body.append("ques16", this.myForm.value.ques16 ?? "");
    body.append("ques17", this.myForm.value.ques17 ?? "");
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, { headers })
      .subscribe((data) => {
        // console.log("headers")
        this.loaderDisplayStyle = "none";
        this.isLoading.emit(false);
        this.isFinished.emit();
      });
  }

  openPopup(n: number) {
    this.popupDisplayStyles[n] = "block";
  }

  closePopup(n: number) {
    this.popupDisplayStyles[n] = "none";
  }
}
